import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "@/lib/api";

const ADMIN_EMAIL = "convenceme.app@gmail.com";

export default function AdminRoute({ children }) {
  const [state, setState] = useState({ status: "loading", user: null });
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const user = await getMe();
        if (!active) return;
        if (user.email?.toLowerCase() !== ADMIN_EMAIL.toLowerCase()) {
          navigate("/game", { replace: true });
          return;
        }
        setState({ status: "ok", user });
      } catch (_e) {
        if (active) navigate("/", { replace: true });
      }
    })();
    return () => {
      active = false;
    };
  }, [navigate]);

  if (state.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="admin-loading">
        <div className="font-display text-2xl uppercase">Cargando...</div>
      </div>
    );
  }
  if (state.status !== "ok") return null;
  return React.cloneElement(children, { user: state.user });
}
